class WishlistItem extends HTMLElement {
  handle; removeBtn; btnAdd;
  static selectors = {
    remove: '[data-remove]',
    btnAdd: '[data-cart-add]',
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.handle = this.dataset.handle;
    this.removeBtn = this.querySelector(WishlistItem.selectors.remove);
    this.btnAdd = this.querySelector(WishlistItem.selectors.btnAdd);

    if(this.btnAdd)
      this.btnAdd.addEventListener('click', (e) => this.add(e));

    this.removeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.removeFromWishlist();
    });

    window.addEventListener(Utils.WISHLIST_REMOVED, (e) => {
      if(e.detail == this.handle)
        this.remove();
    });
  }

  removeFromWishlist = () => {
    const wishlist = Utils.getWishlist();
    var index = wishlist.indexOf(this.handle);
    if (index > -1) {
      wishlist.splice(index, 1);
    }
    localStorage.setItem(Utils.WISHLIST, wishlist.join(','));
    window.dispatchEvent(new CustomEvent(Utils.WISHLIST_REMOVED, { detail: this.handle }));
    this.remove();
  }

  add = () => {
    Utils.addTocart({
      form: this.querySelector('form')
    });
  }
  
}
if (!window.customElements.get("wishlist-item")) {
  window.customElements.define("wishlist-item", WishlistItem);
}